import { useMutation } from 'react-query';

import { PutResponse } from '@customTypes/api/Notification';
import { Endpoints, ServiceAPI } from '@service/index';

const usePutNotificationRead = () => {
  return useMutation((notificationId: string) => {
    return ServiceAPI.put<null, PutResponse>(
      Endpoints.NotificationRead(notificationId),
    );
  });
};

export default usePutNotificationRead;
